export default __webpack_public_path__ + "static/media/pague_menos.db96d415.png";